var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"py-4 px-5"},[_c('h2',{staticClass:"info-title mb-2"},[_vm._v(_vm._s(_vm.$t('section.general_info')))]),_c('p',{staticClass:"info-hint mb-4"},[_vm._v(_vm._s(_vm.$t('section.general_info__hint')))]),_vm._l((_vm.infoBlocks),function(ref,index){
var title = ref.title;
var key = ref.key;
var format = ref.format;
return _c('div',{key:index,staticClass:"mb-2"},[_c('div',{staticClass:"text--disabled"},[_vm._v(_vm._s(title))]),_c('div',{},[_vm._v(_vm._s(_vm.getValue(key, format)))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }